import React from 'react'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'

export default function PollCheckDecoration() {
  return (
    <CheckRoundedIcon
      className="rt-poll-decoration"
      aria-hidden="true"
      sx={{
        position: 'absolute',
        right: { xs: -70, sm: -60 },
        top: -90,
        fontSize: { xs: 270, sm: 340 },
        color: '#e98549',
        opacity: 0.1,
        transform: 'rotate(-12deg)',
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  )
}
